import { setGlobalLoading } from '$lib/stores/app/actions';

/** @type {boolean} */
let loadingActive = false;

/**
 * Start showing the global loading overlay. Internal only; use withLoading() from outside.
 * @returns {void}
 */
function start() {
	loadingActive = true;
	setGlobalLoading(loadingActive);
}

/**
 * Stop the loading overlay. Safe to call even if start() was not called.
 * @returns {void}
 */
function stop() {
	loadingActive = false;
	setGlobalLoading(loadingActive);
}

/**
 * Run an async function while showing the global loading overlay. Loading is
 * started before the function runs and stopped in a finally block, so it always
 * stops even on throw or early return. Prefer this over manual start/stop.
 * @param {() => Promise<any>} fn - async function to run
 * @returns {Promise<any>} result of fn()
 */
async function withLoading(fn) {
	start();
	try {
		return await fn();
	} finally {
		stop();
	}
}

/**
 * Singleton loading service. Use withLoading() for most cases; use stop() for edge cases
 * start() is not exposed.
 */
export const loadingService = {
	stop,
	withLoading,
	/**
	 * Whether the overlay is currently shown (for tests or debugging).
	 * @returns {boolean}
	 */
	get running() {
		return loadingActive;
	},
};
